export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const CONVERT_CURRENCY = "CONVERT_CURRENCY";
export const DISPLAY_API_USAGE = "DISPLAY_API_USAGE";